<script>
	import Contact from "../../components/Contact.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import Claimant from "../../components/Claimant.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { referralTypes } from "../../config";
	import registrationTypes from "../../config/registrationTypes";

	export let title = null;
	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;

	if (!disabled) {
		$pageNumber = pageIndex;
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const initialise = () => {
		console.log($model);
	};

	initialise();
</script>

<PageSection>
	<h2>Your Contact Details</h2>

	<Contact
		bind:title={$model.Contact.Title}
		bind:firstName={$model.Contact.FirstName}
		bind:surname={$model.Contact.Surname}
		bind:dateOfBirth={$model.Contact.DateOfBirth}
		bind:emailAddress={$model.Contact.EmailAddress}
		bind:phoneNumber={$model.Contact.PhoneNumber}
		bind:address={$model.Contact.Address}
		idPrefix="contact"
		isRegistrationUpdate={$model.IsRegistrationUpdate}
		showDoB={true}
		{required}
		{disabled}
	></Contact>

	<FormRow>
		<FormColumn>
			<label for="whereDidYouHear" class:isrequired={required}>Where did you hear about this class action?</label>
			<Select
				{required}
				{disabled}
				id="whereDidYouHear"
				bind:value={$model.WhereDidYouHear}
				optionList={referralTypes}
				textProperty="name"
				valueProperty="name"
			></Select>
		</FormColumn>
	</FormRow>

	<FormRow>
		<FormColumn>
			<label for="regType" class:isrequired={required}>Registration Type</label>
			<Select
				{required}
				disabled={disabled || $model.IsRegistrationUpdate}
				id="regType"
				bind:value={$model.RegistrationType}
				optionList={registrationTypes.options}
				textProperty="name"
				valueProperty="value"
			></Select>
		</FormColumn>
	</FormRow>

	{#if $model.RegistrationType}
		<div class="investor-details">
			<Claimant
				bind:registrationType={$model.RegistrationType}
				bind:investor={$model.InvestorDetails}
				bind:claimant={$model.Claimant}
				bind:jointHoldings={$model.JointHoldings}
				contact={$model.Contact}
				isRegistrationUpdate={$model.IsRegistrationUpdate}
				{disabled}
				{required}
			></Claimant>
		</div>
	{/if}

	<FormRow>
		<div class="col-md-8 col-sm-12">
			<Checkbox
				{disabled}
				required="true"
				bind:checked={$model.PrivacyPolicyConfirmed}
				label="I agree to the Shine Lawyers <a href='https://www.shine.com.au/privacy-policy' title='Privacy Policy' target='_blank'>Privacy Policy</a>"
				id="privacy"
			></Checkbox>
		</div>
	</FormRow>

	{#if !disabled}
		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons
					{persistUrl}
					previousPage={$model.IsRegistrationUpdate
						? `RegistrationUpdate?token=${$model.RegistrationToken}`
						: previousPage}
					{nextPage}
					tealiumTag={true}
					pageName={title}
				></NavigationButtons>
			</div>
		</div>
	{/if}
</PageSection>

<style>
	.investor-details {
		margin-bottom: 20px;
	}
</style>
